import { motion } from "framer-motion";

const WhySylvaSection = () => {
  const differentiators = [
    {
      title: "Indépendant & Orienté Solutions",
      description:
        "Notre analyse part de la situation du propriétaire, de ses objectifs et des caractéristiques de son actif forestier. Nous recherchons ensuite la solution la plus adaptée, en toute indépendance vis-à-vis des opérateurs techniques susceptibles d'intervenir ensuite.",
    },
    {
      title: "Expertise en Structuration Foncière",
      description:
        "Expérience en aménagement immobilier, désormais appliquée au foncier rural et forestier.",
    },
    {
      title: "Réseau Local Solide",
      description:
        "Relations établies avec notaires, maires et professionnels forestiers dans toute la région.",
    },
    {
      title: "Terrain, Pas Standardisation",
      description:
        "Chaque forêt est unique. Nous arpentons le terrain et comprenons son contexte spécifique.",
    },
    {
      title: "Alignement Long Terme",
      description:
        "Nous pensons en décennies, pas en trimestres. Notre succès est lié au vôtre.",
    },
    {
      title: "Discrétion Garantie",
      description:
        "Affaires familiales sensibles et transactions foncières traitées en toute confidentialité.",
    },
  ];

  return (
    <section
      id="why-sylva"
      data-testid="why-sylva-section"
      className="py-24 md:py-32 bg-cream"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <p className="text-xs uppercase tracking-[0.2em] text-gold font-sans font-semibold mb-4">
            Notre Différence
          </p>
          <h2
            className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight text-forest"
            data-testid="why-sylva-headline"
          >
            Pourquoi Sylva Invest
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {differentiators.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-bone p-8"
              data-testid={`differentiator-${index}`}
            >
              <h3 className="font-serif text-lg md:text-xl text-forest mb-3">
                {item.title}
              </h3>
              <p className="font-sans text-sm text-gray-600 leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySylvaSection;
